import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { FullWidthContainer } from '@sorare/core/src/atoms/layout/FullWidthContainer';
import { AlgoliaCardIndexesNames } from '@sorare/core/src/contexts/config';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import idFromObject from '@sorare/core/src/gql/idFromObject';

import useDefaultFilters from '@sorare/marketplace/src/hooks/useDefaultFilters';

import NBACardSearch from 'components/searchCards/NBACardSearch';
import { commonCardsFilters } from 'components/searchCards/cardFilters';

const sorts: AlgoliaCardIndexesNames = [
  'Cards Highest Average Score',
  'Cards Player Name',
];

const TestPage = () => {
  const { currentUser } = useCurrentUserContext();

  const sellingDefaultFilters = useDefaultFilters({
    userId: idFromObject(currentUser?.id),
    rarity: Rarity.common,
  });

  if (!currentUser) return null;

  return (
    <FullWidthContainer>
      <NBACardSearch
        sorts={sorts}
        analyticsTags={['NBA', 'Swap']}
        cardFilters={commonCardsFilters}
        defaultFilters={sellingDefaultFilters}
        hideStackedSwitch
        includeCommonCards
        hideOwner
        defaultHitsPerPage={100}
        hideSavedFilters
        alwaysShowFavoriteButton={false}
        canSellCommon
      />
    </FullWidthContainer>
  );
};

export default TestPage;
